import { useQuery } from "@tanstack/react-query";
import { contractsRepository } from "@/repositories/contracts";
import { useAuth } from "@/hooks/useAuth";

export interface ContractUnitRow {
  id: string;
  contract_id: string;
  unit_id: string;
  rent_amount: number;
  service_fees: {
    sewage?: number | null;
    maintenance?: number | null;
    cleaning?: number | null;
    security?: number | null;
  };
  position: number;
  unit: {
    id: string;
    unit_number: string;
    floor_number: number | null;
    bedrooms: number | null;
    bathrooms: number | null;
    purpose: string | null;
  } | null;
}

// Reads the contract_units junction for one contract, joined with the basic
// unit fields needed for display. Returns an empty array for legacy
// single-unit contracts (those have zero rows in the junction); callers can
// then fall back to contracts.unit_id for display.
export function useContractUnits(contractId: string | null | undefined) {
  const { companyId } = useAuth();

  return useQuery({
    queryKey: ["contract-units", contractId, companyId],
    enabled: !!contractId && !!companyId,
    queryFn: async (): Promise<ContractUnitRow[]> => {
      const data = await contractsRepository.listContractUnits(
        contractId!,
        companyId!,
      );
      return (data ?? []) as unknown as ContractUnitRow[];
    },
  });
}
